import { STRINGS } from '../../constants';
import apiCaller from '../http';
import URLS from '../urls';

const updateProfile = async (
  profileId,
  values,
  isModalVisible,
  onRefresh,
  setError,
  logoutHandler,
) => {
  await apiCaller
    .put(`${URLS.WORKSHOP_PROFILE}${profileId}${URLS.WORKSHOP_PROFILE_EDIT}`, values)
    .then((resp) => {
      if (resp.data !== undefined) {
        isModalVisible(false);
        setError(null);
        onRefresh();
      } else {
        setError(STRINGS.common.error404Text);
      }
    })
    .catch((e) => {
      if (e.message === STRINGS.settings.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.settings.error400Template) {
        setError(STRINGS.settings.error400Text);
      }
      if (e.message === STRINGS.settings.error500Template) {
        setError(STRINGS.settings.error500Text);
      }
    });
};

export default updateProfile;
